import { render, staticRenderFns } from "./ImageMagnifier.vue?vue&type=template&id=0bb3f9cc&scoped=true"
import script from "./ImageMagnifier.vue?vue&type=script&lang=ts"
export * from "./ImageMagnifier.vue?vue&type=script&lang=ts"
import style0 from "./ImageMagnifier.vue?vue&type=style&index=0&id=0bb3f9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb3f9cc",
  null
  
)

export default component.exports